// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3SmC8","content":"styles_content__3ZZ05","selectAll":"styles_selectAll__1z8ZZ"};